import { render, staticRenderFns } from "./MixProdukHome.vue?vue&type=template&id=57287b82&"
import script from "./MixProdukHome.vue?vue&type=script&lang=js&"
export * from "./MixProdukHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports